import { Component, OnInit } from '@angular/core';
import { IdP } from '../models/idp';
import { Alert } from '../shared/alert';
import { AppTitle } from '../shared/title';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityService } from '../services/identity.service';
import { FindIdP } from '../models/find_idp';
import { validateToken } from '../services/account.service.moc';
import { isDateSet, dateFormat } from '../shared/date_helper';
import { IdPRequest } from '../models/idp_request';

@Component({
  selector: 'app-idps',
  template: `
    <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-6 col-md-6 col-xs-12">
          <alert [alert]="msg" style="display:block;"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-8 col-md-7 col-xs-12">
          <button type="button" class="btn btn-large btn-primary" (click)="add()">Add New</button>
          <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
      </div>
    </div>
    <div class="col-lg-8 col-md-12 col-xs-12">
      <div class="card">
        <table class="table">
          <thead>
            <tr>
                <th>Name</th>
                <th>Domain Names</th>
                <th>User Provisioning</th>
                <th>Protocol</th>
                <th>Updated At</th>
                <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of data; let i = index">
              <td style="width:15%;">{{ row.name }}</td>
              <td style="width:15%;">{{ row.domainNames }}</td>
              <td style="width:15%;">
                <span class="btn-link" style="cursor: pointer;" (click)="updateProvisioning(row)">
                  {{ row.userProvisioning==false ? 'Enable' : 'Disable' }}
                </span>
              </td>
              <td style="width:15%;">{{ row.protocol }}</td>
              <td style="width:15%;">{{ printDate(row.updatedAt) ? printDate(row.updatedAt) : printDate(row.createdAt) }}</td>
              <td style="width:25%;">
                  <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                  <span title="Test" class="btn-link" style="cursor: pointer;" (click)="endpoints(row)">Endpoints</span> |
                  <span title="Remove IdP" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="remove(row)" style="cursor:pointer;"></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,
})
export class IdpsComponent implements OnInit {
  data: IdP[];
  msg: Alert;
  msgHead: Alert;
  acctNumber: string;
  hasAccess: boolean;

  constructor(private title: AppTitle, private activatedRoute: ActivatedRoute, private idsvc: IdentityService, private router: Router) {
    this.hasAccess = true;
    this.msg = new Alert();
    this.msgHead = new Alert();
    title.setTitles({
			title: 'Identity Providers',
			dashboard: 'Identity Providers'
		});
		this.title.setBreadcrumbs([
			{ title: 'Identity Providers', link: `` }
		]);
  }

  ngOnInit() {
    this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
    if (this.acctNumber != null) {
			this.idsvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.idsvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				})
		}
		this.loadData();
  }

  loadData() {
    this.data = [];
    this.idsvc.findIdPApi(this.acctNumber, new FindIdP())
      .subscribe((idps: IdP[]) => {
        this.data = idps;
      }, err => {
        console.log(err);
        if (this.idsvc.isErrNotFound(err)) {
          this.msg.warning(this.idsvc.getUserError(err));
        } else {
          if (this.idsvc.isErrUnauthorized(err)) {
            this.hasAccess = false;
            this.msg.error(this.idsvc.getUserErrorDefault(err));
          } else {
            this.msg.error(this.idsvc.getUserErrorDefault(err));
          }
        }
      });
  }

  refresh() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.loadData();
		this.msg.close();
  }

	printDate(d: Date): string {
		let df = '01/02/2006 03:04 PM';
		if (isDateSet(d)) {
			return dateFormat(d, df);
		}
		return '';
  }

  add() {
    this.router.navigate([`idp/${this.acctNumber}/idps/add`]);
		return;
  }

  endpoints(row: IdP) {
    this.router.navigate([`idp/${this.acctNumber}/idps/${row.id}/endpoints`], { queryParams: { name: row.name } });
		return;
  }

  remove(row: IdP) {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.idsvc.removeIdPApi(this.acctNumber, row.id)
			.subscribe(res => {
				this.data.splice(this.data.indexOf(row), 1);
			}, err => {
				console.log(err);
				let e = this.idsvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
	}

  updateProvisioning(row: IdP) {
    let req = new IdPRequest();
    req.id = row.id;
    req.name = row.name;
    req.protocol = row.protocol;
    req.domainNames = row.domainNames;
    req.userProvisioning = !row.userProvisioning;
    
    this.idsvc.updateIdPApi(this.acctNumber, req)
			.subscribe(res => {
        this.loadData();
      }, err => {
				console.log(err);
				let e = this.idsvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
  }

  edit(row: IdP) {
		this.router.navigate([`idp/${this.acctNumber}/idps/${row.id}/edit`]);
		return;
	}
}
